import { render, staticRenderFns } from "./ModalEditCampaign.vue?vue&type=template&id=584d640b&"
import script from "./ModalEditCampaign.vue?vue&type=script&lang=js&"
export * from "./ModalEditCampaign.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./ModalEditCampaign.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports